import { defineMessages } from 'react-intl';

export const templateTableMessages = defineMessages({
  nameHeader: {
    id: 'templateTable.nameHeader',
    defaultMessage: 'Name',
    description: 'Template table name header',
  },
  descriptionHeader: {
    id: 'templateTable.descriptionHeader',
    defaultMessage: 'Description',
    description: 'Template table description header',
  },
  statusHeader: {
    id: 'templateTable.statusHeader',
    defaultMessage: 'Status',
    description: 'Template table status header',
  },
  updatedOnHeader: {
    id: 'templateTable.updatedOnHeader',
    defaultMessage: 'Updated on',
    description: 'Template table updatedOn header',
  },
  actionsHeader: {
    id: 'templateTable.actionsHeader',
    defaultMessage: 'Actions',
    description: 'Template table actions header',
  },

  updatedOn: {
    id: 'templateTable.updatedOn',
    defaultMessage: '{date} at {time}',
    description: 'Template table updatedOn',
  },

  actionsUseAsNewProduct: {
    id: 'templateTable.actionsUseAsNewProduct',
    defaultMessage: 'Use as new Product',
    description: 'Template table actions use as new product',
  },
  actionsEdit: {
    id: 'templateTable.actionsEdit',
    defaultMessage: 'Edit Tailoring Proposal',
    description: 'Template table actions edit',
  },
  actionsPublish: {
    id: 'templateTable.actionsPublish',
    defaultMessage: 'Publish Tailoring Proposal',
    description: 'Template table actions publish',
  },
  actionsPrivate: {
    id: 'templateTable.actionsPrivate',
    defaultMessage: 'Set Tailoring Proposal as private',
    description: 'Template table actions private',
  },
  actionsDelete: {
    id: 'templateTable.actionsDelete',
    defaultMessage: 'Delete Tailoring Proposal',
    description: 'Template table actions delete',
  },
});
